import type { CaseStudy } from "./types";

const cs: CaseStudy = {
  slug: "luanda-metapag",
  founder: "Rafael Costa",
  company: "MetaPag",
  city: "São Paulo",
  country: "Brasil",
  pillar: "bootcamp",
  outcomeShort: {
    en: "From R$0 to R$420k ARR in 6 months",
    fr: "De 0 R$ à 420 k R$ d'ARR en 6 mois",
  },
  title: {
    en: "How MetaPag reached R$420k ARR in 6 months after the Founder GTM bootcamp",
    fr: "Comment MetaPag a atteint 420 k R$ d'ARR en 6 mois après le bootcamp Founder GTM",
  },
  subtitle: {
    en: "A B2B PIX reconciliation tool found its niche in mid-market Brazilian e-commerce — outbound by week 3.",
    fr: "Un outil B2B de réconciliation PIX a trouvé son niche dans l'e-commerce mid-market brésilien — outbound dès la semaine 3.",
  },
  body: {
    en: {
      context: "Rafael had spent 8 months building a PIX reconciliation API in his spare time while working at Stone. The tech worked beautifully. He had zero customers and zero idea who his ICP was.",
      challenge: "Brazil's PIX ecosystem is crowded with 200+ fintech tools. Rafael needed to find a wedge, validate willingness-to-pay, and ship outbound — fast — before his runway ran out.",
      approach: "He joined the 8-week Founder GTM bootcamp (Portuguese cohort). Week 1–2: ICP interviews with 25 e-commerce CFOs. Week 3: defined the wedge (Shopify Plus + Bling integrations only). Week 4–6: outbound to 800 stores, closed 12 paid pilots at R$1 200/mo. Week 7–8: case-study-driven content engine on LinkedIn.",
      outcome: "Crossed R$35k MRR (≈ R$420k ARR) by month 6. Customer acquisition cost stabilised at R$2 100 with R$28k LTV. Now hiring his first SDR.",
      quote: "The bootcamp forced me to talk to 25 people before writing a single line of new code. That single change saved me a year.",
      quoteAuthor: "Rafael Costa · Founder, MetaPag",
    },
    fr: {
      context: "Rafael avait passé 8 mois à construire une API de réconciliation PIX sur son temps libre tout en travaillant chez Stone. La tech fonctionnait à merveille. Il avait zéro client et zéro idée de son ICP.",
      challenge: "L'écosystème PIX du Brésil est saturé avec plus de 200 outils fintech. Rafael devait trouver un wedge, valider le willingness-to-pay et lancer l'outbound — vite — avant la fin de sa runway.",
      approach: "Il a rejoint le bootcamp Founder GTM de 8 semaines (cohorte portugaise). S1–2 : entretiens ICP avec 25 CFOs e-commerce. S3 : définition du wedge (intégrations Shopify Plus + Bling uniquement). S4–6 : outbound à 800 boutiques, 12 pilotes payants closés à 1 200 R$/mois. S7–8 : moteur de contenu LinkedIn fondé sur les case studies.",
      outcome: "Franchissement de 35 k R$ MRR (≈ 420 k R$ ARR) au 6ᵉ mois. CAC stabilisé à 2 100 R$ pour une LTV de 28 k R$. Recrutement de son premier SDR en cours.",
      quote: "Le bootcamp m'a forcé à parler à 25 personnes avant d'écrire une seule ligne de code en plus. Ce seul changement m'a fait gagner un an.",
      quoteAuthor: "Rafael Costa · Fondateur, MetaPag",
    },
  },
  relatedBootcampSlug: "founder-gtm",
};
export default cs;
